module.exports = "/_next/static/images/water-service-header-0f8f035c20cd0af4c11712cb509e10ee.webp";